import isObject from 'lodash/isObject';

import isEmptyFilterValue from './isEmptyFilterValue';

const setValue = (obj = {}, path = '', value) => {
  const [name, ...otherPath] = Array.isArray(path) ? path : path.split('.');

  const newValue = otherPath.length
    ? setValue(obj[name], otherPath, value)
    : value;

  if (Array.isArray(obj)) {
    return [
      ...obj.slice(0, Number(name)),
      newValue,
      ...obj.slice(Number(name) + 1),
    ];
  }

  if (isEmptyFilterValue(newValue)) {
    const { [name]: _, ...other } = obj;
    return other;
  }

  return {
    ...obj,
    [name]: newValue,
  };
};

const set = (obj, params, value) => {
  if (isObject(params) && !Array.isArray(params)) {
    return Object.keys(params).reduce(
      (acc, key) => setValue(acc, key, params[key]),
      obj
    );
  }

  return setValue(obj, params, value);
};

export default set;
